import React from 'react';
import Textfield from '@atlaskit/textfield';
import { DisplayMode } from '../../RenderForm';
import { FieldDisabledWrapper, ViewWrapper } from '../common/questionWrappers';
export var ViewNumber = function ViewNumber(_ref) {
  var id = _ref.id,
    value = _ref.value,
    displayMode = _ref.displayMode,
    jiraField = _ref.jiraField;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(Textfield, {
      id: id
      // Since Jira adds .0 to the end of the number, we will omit it
      ,
      value: jiraField ? value === null || value === void 0 ? void 0 : value.replace(/\.0$/, '') : value,
      isReadOnly: true,
      width: "small",
      label: "number"
      // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
      ,
      "aria-label": "number field",
      title: "number",
      placeholder: ""
      // eslint-disable-next-line @atlassian/a11y/no-interactive-element-to-noninteractive-role
      ,
      role: "presentation"
    }));
  }

  // Since Jira adds .0 to the end of the number, we will omit it
  return /*#__PURE__*/React.createElement(ViewWrapper, null, jiraField ? value === null || value === void 0 ? void 0 : value.replace(/\.0$/, '') : value);
};